module.exports = __webpack_public_path__ + "img/treppengelaender.4b2985ba.jpg";